import Vue from 'vue';

import {IHubsStore, IHub, initialHub, IActionsSignature} from "@/models/StoreModels";
import * as services from "@/services/services";

const initialState = (): IHubsStore => {
  return {
    hubList: [],
    favoriteHubId: 0,
  };
};


const getters = {
  getHubList(state: IHubsStore): IHub[] {
    return state.hubList;
  },

  getHubById(state: IHubsStore): (id: number) => IHub {
    const hubList = state.hubList;

    return (id: number): IHub => {
      return hubList.find((hub: IHub) => {
        return hub.id === id;
      }) as IHub || initialHub();
    };
  },

  getHubAddressById(state: IHubsStore): (id: number) => string {
    return (id: number): string => {
      return getters.getHubById(state)(id).address;
    };
  },

  existsOnlyOneHub(state: IHubsStore): boolean {
    return state.hubList.length === 1;
  },
};


const actions = {
  reset({commit}: IActionsSignature<IHubsStore>) {
    commit('reset');
  },

  init({commit}: IActionsSignature<IHubsStore>) {
    return services.apiCaller.GET("/hubs", [])
      .then((myHubList: IHub[]) => {
        if (myHubList) {
          commit('setHubList', myHubList);
          return  'success init hubList';
        }
        return 'load, but nil hubList (?)';
      })
      .catch(err => 'fail init promotions');
  },

  setHubList({commit}: IActionsSignature<IHubsStore>, hubList: IHub[]) {
    commit('setHubList', hubList);
  },

  addHub({commit}: IActionsSignature<IHubsStore>, hub: IHub) {
    commit('addHub', hub);
  },
};


const mutations = {
  setHubList(state: IHubsStore, hubList: IHub[]) {
    Vue.set(state, 'hubList', hubList);
  },

  addHub(state: IHubsStore, hub: IHub) {
    // todo: verify this. also, prevent to add the same hub more than once
    const hubList = state.hubList;
    hubList.push(hub);
    Vue.set(state, 'hubList', hubList);
  },

  reset(state: IHubsStore) {
    // state = Object.assign(state, initialState());
    Vue.set(state, 'hubList', []);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
